export default __webpack_public_path__ + "static/media/exclamation.b83f15ed.svg";